import React from "react";

const HeadingOneStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.75 2.75H3.25M3.25 2.75H4.25M3.25 2.75V9.75M3.25 9.75V17.25M3.25 9.75H11.75M3.25 17.25H1.75M3.25 17.25H4.25M11.75 9.75V2.75M11.75 9.75V17.25M11.75 2.75H13.25M11.75 2.75H10.75M11.75 17.25H13.25M11.75 17.25H10.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 10V14.5M16.5 14.5H15M16.5 14.5H17.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HeadingOneStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;